import { SignUpSM } from "../service-models/sign-up.s-m";
import { BaseViewModel } from "./base.viewmodel";

export class SignUpViewModel  implements BaseViewModel {
    PageTitle: string = 'Sign up';
    userDetails:SignUpSM=new SignUpSM()
    constructor() {
        // super();
        // this.addValidations();
    }

    // addValidations() {
    //     this.validationMessages.push(
    //         {
    //             errorMessage: 'Enter your first Name',
    //             errorType: ErrType.Required,
    //             isError: false,
    //             propertyName: 'firstName',
    //             propertyType: ''
    //         },
    //         {
    //             errorMessage: 'Enter your Last Name',
    //             errorType: ErrType.Required,
    //             isError: false,
    //             propertyName: 'lastName',
    //             propertyType: ''
    //         },
    //         {
    //             errorMessage: 'Enter your Email',
    //             errorType: ErrType.Required,
    //             isError: false,
    //             propertyName: 'email',
    //             propertyType: ''
    //         },
    //         {
    //             errorMessage: 'Enter your contact Number',
    //             errorType: ErrType.Required,
    //             isError: false,
    //             propertyName: 'contact',
    //             propertyType: ''
    //         },
    //         {
    //             errorMessage: 'Enter your password',
    //             errorType: ErrType.Required,
    //             isError: false,
    //             propertyName: 'password',
    //             propertyType: ''
    //         }, )


    // }

}

  
